import { ethers } from "ethers";
import abi from "./GlobalPool.json";

const Buy1 = ({ state }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract } = state;
    const contractABI = abi.abi;
    var name = document.querySelector("#pp").value;
    var pp5 = document.querySelector("#pp4").value;
    var pp6 = document.querySelector("#pp5").value;
    const refer = document.querySelector("#hid").value;
    console.log(name, contract);
    console.log(refer);
    console.log("hello");
     
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    function refreshPage() {
      window.location.reload(false);
    }
    
    const addressOfYourContract = '0x8e1858e5fabae5b2f084dd892aab33bdf07ad835';

      const busdContractAddress = '0xf09a02b39e22EB7D60B17070012297Ee0478a0f1';
    const busdContractAbi = `[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]`;

    function refreshPage() {
      window.location.reload(false);
    }
    
  
    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
    
    const amountToApprove = ethers.utils.parseUnits('2560', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }

    
    
//    function register1(address _refer,uint _amount,uint _per,uint _lev,uint _wid,uint _reward,address _team) payable public

// const transaction = await contract.register1('0x11cacC71af4b4F8d01Ed7112ADB0D234eD087eeC',100,125000000,379707,0,0,'0xdbcf3385cac823e00ccea17c260ae7388c9e4e76');
console.log(pp5);
/*
if(pp5=="0xE7259E618A9FB4AA2C8463254d1c72A15C821604")
{

}
else if(pp5=="0x9683811be1C4dDbaac0BC520F5331383df7b480b")
{

}
else if(pp5=="0x2E821dDfB9f398B305Ee5e45005D8E240Ad570a9")
{
  
}
else if(pp5=="0x310DDc195D3eE1d1C0C773086aa213e06B46aC52")
{
  
}
else if(pp5=="0x2e02dAfea838509cf699f1F6B8644f139331Ce65")
{
  
}
else if(pp5=="0x99004d52E89290bE444EE61E6C3d99fd1BDaf032")
{
  
}
else if(pp5=="0xCAccAAdCF362D572aE295C5987d9a8f05D3f546e")
{
  
}
else if(pp5=="0xee0b22fdbBE4605C62894d089F500ccDd8a29BF3")
{
  
}
else if(pp5=="0xe22524F353A5DDe835b5E83F577730Be52787149")
{
  
}
else if(pp5=="0x6b9dD8B1325b5853e59edff563dAC7D8c981bA96")
{
  
}
else if(pp5=="0x376a2856A71c588FCf40E8b36C305CBC317736eb")
{
  
}
else if(pp5=="0xF5A242259810178f0224e39f9C0a21956A5c6eA2")
{
  
}
else if(pp5=="0xc599C06258d81ce9cef9749E05Bda1fE8eB275d4")
{
  
}
else if(pp5=="0x47c246b913844c4F7f959682C0B26CAEd1cF70bd")
{
  
}
else if(pp5=="0x1974Db0f674210B68a32F02930879E957039D026")
{
  
}
else if(pp5=="0xD929Acf3b2E562506B48fd47FA18e5a09FD190c7")
{
  
}
else if(pp5=="0x1b50aa94751149c236bf5789BB3261Fe2c917c1A")
{
  
}
else if(pp5=="0x29aB8026C1688AfE0A01c05837DE5c7C41d954EA")
{
  
}
else if(pp5=="0x2EC93AE21d968AD1da5c62b34aC39C0D8F4E3910")
{
  
}
else if(pp5=="0xb2d27a3A3e04536d0CC92676cCF50678F040a600")
{
  
}
else if(pp5=="0x0cE08000A4AE9C29d838A8a48cE75d72FbbE5476")
{
  
}
else if(pp5=="0x925aF306f20513B53126bD11893B1AE9Ea4b4b40")
{
  
}
else if(pp5=="0xb0c72C2A2496b80FC33e35e1f7B0d0d1021939b5")
{
  
}
else if(pp5=="0xF5060a1d551957b889Da648c83a1fb006efF5e92")
{
  
}
else if(pp5=="0xAba69B25DFa14E49dA67Ae1fbC909834F7d098f1")
{
  
}
else if(pp5=="0x887feD6bFb3271e48b1eb6E66514fDA77fb4bDa2")
{
  
}
else if(pp5=="0x25c8483aD68652b46fE6e997632867A857094267")
{
  
}
else if(pp5=="0xB134D151a2ff759C8d680B0cc543CC50ECCA490c")
{
  
}
else if(pp5=="0xBa468c0E9FA55daf86C587235084e317E0dF51b3")
{
  
}
else if(pp5=="0x4Df2D85aCB28392727a981604dAec361000f282e")
{

}
else if(pp5=="0x3EA780e732C6CcDb93b35c7785388c49726F0DdE")
{
  
}
else if(pp5=="0xB89f3c80FdD556A6da2d4A8d2E8c00A621696Bd4")
{
  
}
else if(pp5=="0x5a88f557246565cDfA91C6AD025B98d5a8921534")
{
  
}
else if(pp5=="0x91E0a3F694A40720597f3A0c1E05730e7CDECfe2")
{
  
}
else if(pp5=="0x888a53Aa74a05062B47dcF397C29606c6da60409")
{
  
}
else if(pp5=="0xf29468C3083eb80896919Efa4309AC3D47679a9D")
{
  
}
else if(pp5=="0xb4aB5527362D7D3f80eD6F67e1fDB1Cfe068542F")
{
  
}
else if(pp5=="0x975a4c0e1f138B2A017B85384a449d5dCcEc9576")
{
  
}
else if(pp5=="0x8E1753304d35a3328642390eE45D373230A6E718")
{
  
}
else if(pp5=="0xEe225857eCCdd1E1E211D46973DfDd068602608E")
{
  
}
else if(pp5=="0xc5E82D9aa4B4eA74ac72EF919D7cf159780B9FE0")
{
  
}
else if(pp5=="0x3B4330695651b592a56Db37B3A404728A5cA2408")
{
  
}
else if(pp5=="0xA5721Cc32e08432A218211aC0F623cc8aE189E68")
{
  
}
else if(pp5=="0x34d64835959Ea21b1d2B82D999E78574FCE2382C")
{
  
}
else if(pp5=="0x9A002A0b267DdE55A27065f23Ed52ec399309d1F")
{
  
}
else if(pp5=="0x7f6790B4885aac01d9862655bFE58B4aDFD59Fe1")
{
  
}
else
{
 
*/
const transaction = await contract.trade(1, {
              gasLimit: 1200000,
          
        }); 
    await transaction.wait();

 



    console.log("Transaction is done");
    //  }   
    refreshPage();
  };
  return (
    <>
     <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
        <form onSubmit={buyChai}>
        <input type="hidden" id ="name"></input>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
  <button
  
    type="submit"
    id="sample"
    className="btn btn-accent-icon"
     style={{ backgroundColor: "yellowgreen", color: "white" }}
  >
    Trade
    
  </button>
</div>

        </form>
      </div>
    </>
  );
};
export default Buy1;